var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#FBF0CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1875 21.3125V21.8125H32.6875H36.625C36.7637 21.8125 36.875 21.9238 36.875 22.0625V25.6875H19.125V22.0625C19.125 21.9238 19.2363 21.8125 19.375 21.8125H23.3125H23.8125V21.3125V20.125H24.5V21.3125V21.8125H25H31H31.5V21.3125V20.125H32.1875V21.3125ZM19.375 37.875C19.2363 37.875 19.125 37.7637 19.125 37.625V28.2812H36.875V37.625C36.875 37.7637 36.7637 37.875 36.625 37.875H19.375Z",
    fill: "#E9B500",
    fillOpacity: 0.85,
    stroke: "#E9B500"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeContainer);
export default __webpack_public_path__ + "static/media/orange-container.a62ee6d6ba67a72825a1ea2821bdc2ca.svg";
export { ForwardRef as ReactComponent };